<template>
  <div class="container">
    <div class="header">
      <div class="w1250">
        <z-header></z-header>
      </div>
    </div>
    <z-navigation :update="true" form-name="form" v-on:submit_form="submitForm"></z-navigation>
    <div class="main w1200" v-if="pageInfo.hasOwnProperty('pageInfo')">
      <div v-show="true" style="height: 30px;">&nbsp;</div>
      <form-card v-if="pageInfo.hasOwnProperty('form')" ref='form' :form-data="pageInfo.form.field" :form-inputs="pageInfo.form.form_field" :form-rules="pageInfo.form.rules" :id="pageInfo.form.id" :options="pageInfo.form.options" :name="pageInfo.form.name" v-on:formEvent="formEvent">
        <div slot="formHeader" class="bzBg">
          <div class="bzDiv">
            <div class="bzCon-two fL" style="width:900px; margin-top: 12px; font-size: 18px;">
              <span>修改资质证明</span>
            </div>
            <div class="bzBtn-reject fL">
              <el-button class="fL marR20" style="width: 120px" @click="cancelForm()">取消</el-button>
              <el-button type="primary" class="fL" style="width: 120px;" @click="submitForm(pageInfo.form.options.ref)">提交审核
              </el-button>
            </div>
          </div>
          <z-alert :tag-msg="pageInfo.pageInfo.tag_msg"></z-alert>
          <el-card class="padd9" v-if="pageInfo.cards.hasOwnProperty('base')">
            <div class="cont-m">
              <h2>基本信息</h2>
              <z-license-status :exception="(pageInfo.cards.base.status==3 || pageInfo.cards.base.status==4 || pageInfo.cards.base.status==5)" :reason="pageInfo.cards.base.reason" v-if="pageInfo.cards.base.status==3 || pageInfo.cards.base.status==4 || pageInfo.cards.base.status==5" :status="pageInfo.cards.base.status"></z-license-status>
              <div class="clearfix"></div>
              <table width="1140" border="0" cellspacing="0" cellpadding="0">
                <tr v-for="(data,key) in pageInfo.cards.base.data" :key="key">
                  <td width="74" height="50" align="left" valign="top" class="base-td-title">{{ data.label }}:</td>
                  <td width="1066" align="left" valign="top" class="base-td-value">{{ data.value }}</td>
                </tr>
              </table>
            </div>
          </el-card>
          <div style="padding-top: 20px;padding-bottom: 15px;font-size: 18px;line-height: 18px;">上传资质信息</div>
        </div>
      </form-card>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import FormCard from "@/components/form/Form";
import Navigation from "@/components/Navigation";
import { getData, saveData } from "../utils/utils";
import qs from 'qs';
export default {
  name: "UpdateLicense",
  components: {
    "form-card": FormCard,
    "z-navigation": Navigation
  },
  data: function() {
    return {
      pageInfo: {},
      options: {},
      formValidate: false,
      formData: {},
      tagMsg: {},
      packageId: 0,
      isDisable: true
    };
  },
  computed: {
    isBrandZZFlag: function () {
      return window.location.host.includes('brand')
    },
  },
  watch: {
    pageInfo: function(newData, oldData) {}
  },
  created: function() {
    let packageId = this.$route.params.package_id || 0;
    let params = { package_id: packageId };
    if (this.$route.query["customer_id"]) {
      params["customer_id"] = this.$route.query["customer_id"];
    }
    if (this.$route.query['clientId']) {
      params['clientId'] = this.$route.query['clientId']
    }
    if (this.$route.query['loginParam']) {
      params['loginParam'] = this.$route.query['loginParam']
    }
    getData(this.isBrandZZFlag ? "/api/package/crm/inspect/updateSecond" : "/api/package/updateSecond", params, res => {
      if (res.code == 0) {
        this.pageInfo = res.data;
        if (this.pageInfo.hasOwnProperty("form")) {
          if (this.pageInfo.form.rules instanceof Array) {
            this.pageInfo.form.rules = {};
          }
          if (this.pageInfo.form.form_field.length === 0) {
            this.$message.warning("系统行业错误，没有找到需要的资质信息");
            this.cancelForm();
          }
        }
      } else {
        this.$message.warning(res.msg);
        let url = "/qulification/" + packageId;
        let urlHash = {}
        if (this.$route.query['customer_id']) {
          urlHash['customer_id'] = this.$route.query['customer_id']
        }
        if (this.$route.query['clientId']) {
          urlHash['clientId'] = this.$route.query['clientId']
        }
        if (this.$route.query['loginParam']) {
          urlHash['loginParam'] = this.$route.query['loginParam']
        }
        url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
        this.$router.push(url);
      }
    });
  },
  mounted: function() {
    this.packageId = this.$route.params.package_id || 0;
  },
  methods: {
    submitForm: function(formName) {
      this.$refs["form"].$emit("validate");
      if (this.formValidate && this.isDisable) {
        this.isDisable = false;
        saveData(
          this.pageInfo.form.options.action,
          this.formData,
          res => {
            this.$alert("预计需要2小时可以审核完成","已提交审核",
              {
                confirmButtonText: '确定',
                showClose:false,
                center:true,
                callback: () => {
                  let url = "/qulification/" + this.packageId;
                  let urlHash = {}
                  if (this.$route.query['customer_id']) {
                    urlHash['customer_id'] = this.$route.query['customer_id']
                  }
                  if (this.$route.query['clientId']) {
                    urlHash['clientId'] = this.$route.query['clientId']
                  }
                  if (this.$route.query['loginParam']) {
                    urlHash['loginParam'] = this.$route.query['loginParam']
                  }
                  url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
                  this.$router.push(url);
                }
              }
            );
          },
          errs => {
            getData(this.isBrandZZFlag ? "/api/token/crm/getToken" : "/api/token/getToken", {}, res => {
              if (res.code == 0) {
                this.pageInfo.form.field.token = res.data;
              }
            });
          }
        );
        setTimeout(() => {
          this.isDisable = true;
        }, 500);
      }
      return false;
    },
    formEvent: function(form) {
      this.formValidate = form.valid;
      // this.formData = form.data
      this.formData = Object.assign({}, this.formData, form.data);
      if (this.$route.query["customer_id"]) {
        this.formData["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        this.formData["clientId"] = this.$route.query["clientId"];
      }
      if (this.$route.query["loginParam"]) {
        this.formData["loginParam"] = this.$route.query["loginParam"];
      }
    },
    cancelForm: function() {
      let url = "/qulification/" + this.packageId;
      let urlHash = {}
      if (this.$route.query['customer_id']) {
        urlHash['customer_id'] = this.$route.query['customer_id']
      }
      if (this.$route.query['clientId']) {
        urlHash['clientId'] = this.$route.query['clientId']
      }
      if (this.$route.query['lgoinParam']) {
        urlHash['lgoinParam'] = this.$route.query['lgoinParam']
      }
      url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
      this.$router.push(url);
    },
    previousForm: function() {
      let url = "/qulification/base/" + this.packageId;
      let urlHash = {}
      if (this.$route.query['customer_id']) {
        urlHash['customer_id'] = this.$route.query['customer_id']
      }
      if (this.$route.query['clientId']) {
        urlHash['clientId'] = this.$route.query['clientId']
      }
      if (this.$route.query['lgoinParam']) {
        urlHash['lgoinParam'] = this.$route.query['lgoinParam']
      }
      url = Object.keys(urlHash).length > 0 ? url + `?${qs.stringify(urlHash)}` : url
      this.$router.push(url);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UpdateLicense.vue